import { render, staticRenderFns } from "./pi-my-card-list.vue?vue&type=template&id=797f4f32&scoped=true&"
import script from "./pi-my-card-list.vue?vue&type=script&lang=js&"
export * from "./pi-my-card-list.vue?vue&type=script&lang=js&"
import style0 from "./pi-my-card-list.vue?vue&type=style&index=0&id=797f4f32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797f4f32",
  null
  
)

export default component.exports